'use client'

import { cn } from "@fsg/utils";
import { useSession } from "next-auth/react"

type Props = {
    width: number;
    height: number;
    className?: string;
}

export function UserImage({width, height, className}: Props){
  const { data: sessionData } = useSession()

    return <img referrerPolicy="no-referrer" width={width} height={height} src={sessionData?.user?.picture} className={cn('rounded-full', className)} alt="User profile picture" />
}